import OrderTransportingOrderAvailableConsumersResponse, {
  OrderTransportingOrderAvailableConsumersResponseItem,
} from "../../../../api/raily/order/transporting-order/available-consumers/order-transporting-order-available-consumers.response";
import OrderTransportingOrderAvailableConsumers, {
  OrderTransportingOrderAvailableConsumersItem,
} from "./order-transporting-order-available-consumers";

const createDataItem = (
  responseItem: OrderTransportingOrderAvailableConsumersResponseItem,
): OrderTransportingOrderAvailableConsumersItem => {
  return {
    id: responseItem.id,
    name: responseItem.name,
  };
};

const createData = (
  responseData: OrderTransportingOrderAvailableConsumersResponseItem[],
): OrderTransportingOrderAvailableConsumersItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: OrderTransportingOrderAvailableConsumersResponse,
): OrderTransportingOrderAvailableConsumers => {
  return createData(response.data);
};

const orderTransportingOrderAvailableConsumersFactory = {
  create,
};

export default orderTransportingOrderAvailableConsumersFactory;
